import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'carrierExtract'
})
export class CarrierExtractPipe implements PipeTransform {

  transform(flightList: any[]): any[] {
    if (!Array.isArray(flightList)) return [];

    const list = flightList.flatMap(f =>
      (f.segments || []).flatMap(s =>
        (s.routes || []).map(r => ({
          carrier_name: r.carrier_name,
          carrier_code: r.carrier_code,
          carrier_image: r.carrier_image
        }))
      )
    );

    // 🔥 Remove duplicates by carrier_code
    return list.filter(
      (item, index, self) =>
        index === self.findIndex(t => t.carrier_code === item.carrier_code)
    );
  }

}
